class DropDown extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load = () => {
        // console.log(this);
    };

    events = () => {
        // Obtener el checkbox y el contenedor del dropdown
        const checkbox = this.querySelector(".dropdown__checkbox");

        this.firstElementChild.addEventListener("mouseleave", () => {
            checkbox.checked = false;
        });
    };
}

customElements.define("drop-down", DropDown);
